/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_QualInputs */

const en_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const ar_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تأهيل`)
};

const bn_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const de_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const es_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const fr_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const pt_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const zh_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const tr_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const ru_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

const pl_svtag_qual = /** @type {(inputs: Svtag_QualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#QUAL`)
};

/**
* | output |
* | --- |
* | "#QUAL" |
*
* @param {Svtag_QualInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_qual = /** @type {((inputs?: Svtag_QualInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_QualInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_qual(inputs)
	if (locale === "bn") return bn_svtag_qual(inputs)
	if (locale === "de") return de_svtag_qual(inputs)
	if (locale === "es") return es_svtag_qual(inputs)
	if (locale === "fr") return fr_svtag_qual(inputs)
	if (locale === "pt") return pt_svtag_qual(inputs)
	if (locale === "zh") return zh_svtag_qual(inputs)
	if (locale === "tr") return tr_svtag_qual(inputs)
	if (locale === "ru") return ru_svtag_qual(inputs)
	if (locale === "pl") return pl_svtag_qual(inputs)
	return en_svtag_qual(inputs)
});